<template>
  <div class="home-video-box xm-plain-box">
    <Top />
    <Bottom />
  </div>
</template>

<script>
import Top from './Top'
import Bottom from './Bottom'

export default {
  name: 'ShiPing',
  components: {
    Top,
    Bottom
  }
}
</script>

<style>

</style>